import React, { Component } from 'react';
import Modal from 'shared/components/Modal';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import modalStyles from 'shared/components/modalStyles';
import config from 'shared/config/config';

import {
    MARKETING_POPUP_IMAGE_URL
} from 'shared/utils/Constants'

const styles = theme => ({
    closeIcon: {
        position: 'absolute',
        top: '5px',
        right: '5px',
        color: '#949494',
        opacity: 0.5,
        cursor: 'pointer',
        '&:hover': {
            opacity: 1
        }
    },
    buttonContainer: {
        textAlign: 'center'
    },
    popupHeader: {
        fontFamily: config.main_font,
        color: config.pwa_default_font_color,
    },
    popUpCaption: {
        fontFamily: config.main_font,
        color: config.pwa_default_font_color,
        margin: '1.5rem 0',
        textAlign: 'center',
        fontStyle: 'italic'
    },
    popUpDescription: {
        fontFamily: config.sub_font,
        color: config.pwa_default_font_color,
        margin: '1.5rem 0',
        textAlign: 'left',
    },
    marketingImage: {
        width: '100%',
        height: 'auto'
    },
    button: {
        float: 'left',
        width: '100%',
        marginBottom: '0.5rem',
        textAlign: 'center',
        padding: '0.3rem 1rem',
        fontSize: '1.5rem',
        fontWeight: 600,
        background: config.kiosk_modal_button_action_bg_color,
        border: config.kiosk_modal_button_action_border,
        borderRadius: '3px',
        boxShadow: '0 0 2px #dcdcdc',
        color: config.kiosk_modal_button_action_font_color,
        fontFamily: config.sub_font,
    },
    ...modalStyles()
})

class MarketingPopup extends React.Component {
    close() {
        this.props.onClose();
    }

    render() {
        const { classes, user, open, selectedMarketing } = this.props;

        if (!selectedMarketing) {
            return <div></div>;
        }

        let popUpCaption = null;
        if (selectedMarketing.popup_caption != "") {
            popUpCaption = (
                <div>
                    <p className={classes.popUpCaption}>
                        {selectedMarketing.popup_caption}
                    </p>
                    <hr />
                </div>
            )
        }

        return <Modal disableScrollbar={true}
            disableDrag={true}
            isOpen={open}
            close={this.close.bind(this)}>
            <div className={classes.modalOverlay} onClick={this.close.bind(this)}></div>
            <div className={classes.modal} style={{ background: config.pwa_home_bg_color }}>
                <CloseIcon className={classes.modalCloseIcon} style={{ color: config.pwa_navbar_font_color }} onClick={this.close.bind(this)} />
                <div className={classes.cartDetails}>
                    <div className={classes.popupHeader}>
                        <h3>
                            {selectedMarketing.popup_header}
                        </h3>
                    </div>
                    <hr />
                    <div>
                        <img className={classes.marketingImage} src={MARKETING_POPUP_IMAGE_URL(selectedMarketing.id)} />
                    </div>
                    <hr />
                    {popUpCaption}
                    <p className={classes.popUpDescription}>
                        {selectedMarketing.popup_description}
                    </p>
                </div>
            </div>
        </Modal>
    }
}

const mapStateToProps = state => ({
    user: state.userReducer.user,
    selectedMarketing: state.storyReducer.selectedMarketing
});

export default connect(mapStateToProps, {})(withStyles(styles, { withTheme: true })(MarketingPopup));